import { format, parseISO } from 'date-fns';
import type { App } from 'vue';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm';

export const DATE_TIME_LONG_FORMAT = "yyyy-MM-dd'T'HH:mm";
export const INSTANT_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZ";
export const ZONED_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXXXX";

export function formatDate(value: string | null | undefined): string {
  if (value) {
    return format(parseISO(value), DATE_TIME_FORMAT);
  }
  return '';
}

export function formatMillis(value: number | null | undefined): string {
  if (value) {
    return format(new Date(value), DATE_TIME_FORMAT);
  }
  return '';
}

export function initFilters(app: App): void {
  app.config.globalProperties.$filters = {
    formatDate,
    formatMillis,
  };
}
